/**
 * @generated SignedSource<<362e75e766d026962c7a8f2a6238b6bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUrlPayload",
    "kind": "LinkedField",
    "name": "signUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MemberEditModalQuery_signUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MemberEditModalQuery_signUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7705ab8640a374beb490c8dcfbfc1808",
    "id": null,
    "metadata": {},
    "name": "MemberEditModalQuery_signUrlMutation",
    "operationKind": "mutation",
    "text": "mutation MemberEditModalQuery_signUrlMutation(\n  $input: SignUrlInput!\n) {\n  signUrl(input: $input) {\n    signUrl\n  }\n}\n"
  }
};
})();

node.hash = "dc71a3827f915a6aa070a547ff73013e";

module.exports = node;
